import { create } from "zustand";

const STORAGE_KEY = "farve.welcomeSeen.v1";

type Phase = "closed" | "modal" | "tour";

interface WelcomeState {
  phase: Phase;
  step: number;
  totalSteps: number;
  setTotalSteps: (n: number) => void;
  openModal: () => void;
  startTour: () => void;
  next: () => void;
  back: () => void;
  goTo: (step: number) => void;
  endTour: (markSeen?: boolean) => void;
  dismiss: () => void;
  reopen: () => void;
}

function markSeen() {
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    /* SSR / privacy modes */
  }
}

export function hasSeenWelcome(): boolean {
  try {
    return typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export const useWelcomeStore = create<WelcomeState>((set, get) => ({
  phase: "closed",
  step: 0,
  totalSteps: 5,
  setTotalSteps: (n) => set({ totalSteps: n }),
  openModal: () => set({ phase: "modal", step: 0 }),
  startTour: () => set({ phase: "tour", step: 0 }),
  next: () => {
    const { step, totalSteps } = get();
    if (step >= totalSteps - 1) {
      markSeen();
      set({ phase: "closed", step: 0 });
    } else {
      set({ step: step + 1 });
    }
  },
  back: () => set({ step: Math.max(0, get().step - 1) }),
  goTo: (step) => set({ step }),
  endTour: (alsoMark = true) => {
    if (alsoMark) markSeen();
    set({ phase: "closed", step: 0 });
  },
  dismiss: () => {
    markSeen();
    set({ phase: "closed", step: 0 });
  },
  reopen: () => set({ phase: "tour", step: 0 }),
}));
